import { render, staticRenderFns } from "./CardapioProdutoLista.vue?vue&type=template&id=2b95ddf8&scoped=true"
import script from "./CardapioProdutoLista.vue?vue&type=script&lang=js"
export * from "./CardapioProdutoLista.vue?vue&type=script&lang=js"
import style0 from "./CardapioProdutoLista.vue?vue&type=style&index=0&id=2b95ddf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b95ddf8",
  null
  
)

export default component.exports